module.exports = __webpack_public_path__ + "img/pretoria-capitals-logo-icon.e893810f.png";